const HOUR = 60 * 1000 * 60
const DAY = HOUR * 24

const entities = {
    // DATA COLLECTIONS — auto persist, 24h staleTime
    unit:                   { staleTime: DAY },
    groupType:              { staleTime: DAY },
    priceType:              { staleTime: DAY },
    priceMode:              { staleTime: DAY },
    paymentAccountType:     { staleTime: DAY },
    currency:               { staleTime: DAY },
    language:               { staleTime: DAY },
    companyType:            { staleTime: DAY },
    contactType:            { staleTime: DAY },
    discountType:           { staleTime: DAY },
    portalType:             { staleTime: DAY },
    projectStatus:          { staleTime: DAY },
    taskStatus:             { staleTime: DAY },
    taskPriority:           { staleTime: DAY },
    workState:              { staleTime: DAY },
    workPriority:           { staleTime: DAY },
    machineStatus:          { staleTime: DAY },
    downtimeReason:         { staleTime: DAY },
    qualityResult:          { staleTime: DAY },
    planStatus:             { staleTime: DAY },
    appRoleType:            { staleTime: DAY },
    appRoleApp:             { staleTime: DAY },
    employeeActiveStatus:   { staleTime: DAY },

    // LIST COLLECTIONS — auto persist, 24h staleTime
    bank:                   { staleTime: DAY },

    // FX COLLECTIONS — not persisted (cache: false by type)
    vatTax:                 { staleTime: DAY },

    // SETTINGS COLLECTIONS — auto persist, default staleTime
    adminSettings:          {},
    salesSettings:          {},
    inventorySettings:      {},
    homeSettings:           {},
    crmSettings:            {},
    purchasesSettings:      {},
    projectSettings:        {},

    // ORG COLLECTIONS — auto persist, default staleTime
    organization:           {},

    // COLLECTIONS — auto persist (100-record cap), default staleTime
    document:               {},
    contact:                {},
    product:                {},
    priceList:              {},
    invoice:                {},
    quote:                  {},
    creditNote:             {},
    invoicePayment:         {},
    nserie:                 {},
    paymentTerm:            { staleTime: DAY },
    warehouse:              {},
    rack:                   {},
    location:               {},
    stockAdjustment:        {},
    stockMovement:          {},
    stockShipment:          {},
    stockReceipt:           {},
    stockReservation:       {},
    inventoryLedger:        { cache: false },
    paymentAccount:         {},
    campaign:               {},
    customerGroup:          {},
    productGroup:           {},
    portal:                 {},
    portalAccess:           {},
    project:                {},
    expense:                {},
    purchaseOrder:          {},
    workOrder:              {},
    workCenter:             {},
    machine:                {},
    qualityCheck:           {},
    employee:               {},
    employeePermissions:    { cache: false },

    // SUB-COLLECTIONS — auto persist (100-record cap), default staleTime
    interaction:            {},
    contactPerson:          {},
    itemLocation:           {},
    itemPrice:              {},
    priceListItem:          { cache: false },
    priceListProduct:       { cache: false },
    hall:                   {},
    paymentTransaction:     {
        cache: false,
        transferData: {
            "currency": "currency",
            "currencyName": "currencyName"
        }
    },
    projectTask:            {},
    purchaseOrderLine:      {},
    workOrderLine:          {},
    machineDowntime:        {},
}

export default entities
